import { render, staticRenderFns } from "./ForwardCompanyInvoiceAudit.vue?vue&type=template&id=8e1c7902&scoped=true"
import script from "./ForwardCompanyInvoiceAudit.vue?vue&type=script&lang=ts"
export * from "./ForwardCompanyInvoiceAudit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1c7902",
  null
  
)

export default component.exports